// Visual grammar: consistent shorthand + color per rune category, per the "Visual
// grammar" principle in design/03_Rune_Language.md — distinguishing noun/verb/modifier
// at a glance. This is tokenization only (per that doc); grouping/attachment is
// handled by fixed arity + line breaks, not by shorthand or color.

import { ConceptId } from './concepts';
import { OperatorId } from './operators';

export const CATEGORY_COLOR = {
  concept: '#c9a24b', // matches --accent
  operator: '#4bb3c9', // matches --accent-2
  modifier: '#9b7fd4', // new --accent-3
} as const;

export const CONCEPT_SHORTHAND: Record<ConceptId, string> = {
  mass: 'Ma',
  space: 'Sd', // Space/Distance
  time: 'Ti',
  charge: 'Ch',
  entropy: 'Et',
  energy: 'Eg',
  momentum: 'Mo',
};

export const OPERATOR_SHORTHAND: Record<OperatorId, string> = {
  transfer: 'Tr',
  convert: 'Cv',
  bind: 'Bd',
  separate: 'Sr',
  measure: 'Ms',
  project: 'Pj',
};

export const MODIFIER_SHORTHAND: Record<string, string> = {
  reverse: 'Rv',
  // 'precise' (see modifiers.ts, 2026-08-04 -- renamed from 'small').
  precise: 'Pr',
  unbound: 'Ub',
  continuous: 'Co',
  radial: 'Rd',
  oscillating: 'Os',
};
